<div>
    <div class="edit-button-style section-title" (click)="editScrubberUsageEvent()">
        <img alt="edit" src="/assets/img/edit-icon.svg"> Edit
    </div>
    <snl-side-panel panelType="close" [headerName]="headerName" size="large" [(isOpen)]="openEditScrubberUsage">
        <div sidePanelContent class="largeSidepanelWidth">
           <ng-container *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_1'">
                <div class="editScrubberUsageVal_1">
                    <div class="d-flex justify-content-between">
                        <p class="color__primary body-b1">Is Scrubber in use</p>
                        <snl-switch [toggleState]="toggleScrubberVal" (toggle)="toggleScrubberUsage($event)"
                            [activeText]="'Yes'" [inActiveText]="'No'"></snl-switch>
                    </div>
                    <div class="currenScrubberPoint" *ngIf="toggleScrubberVal === true">
                        <p class="color__secondary body-b">Current scrubber points</p>
                        <p class="color__primary section-title currenScrubberPointVal">{{getScrubberData?.currentScrubberPoints | negativeToBracket}}</p>
                       <div class="fleet-body-b3 editableScrubber body-b">
                            <span>Editable in </span>
                            <a (click)="goToPointsTab()"  class="pointsMang sub-heading-s1">Points management</a> 
                       </div>                                    
                    </div>
                    <ng-container *ngIf="getScrubberData?.hasPreviousChange === true">
                        <div class="datepickerScrubberUsage datepickerScrubberUsageNoChange mt-24" *ngIf="noChangeScrubberEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                                (selectedDate)="scrubberUsageDate($event)" 
                                title="Effective date of change"
                                [min]="minSelectableDate"
                                [startMonthDate]="effectiveDate"
                                [setDefaultDate]="false"
                                class="scrubberEffectiveDate">
                            </snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input reasonForchangeScrubber editPoolPointsVal_1ReasonInput mt-24">
                            <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                                [value]="scrubberUsageReason"
                                [isError]="isTextError" (fieldValue)="scrubberUsagefieldValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_2_NoCase'">
                <div class="editScrubberUsageVal_2">
                    <div class="d-flex justify-content-between">
                        <p class="color__primary body-b1">Is Scrubber in use</p>
                        <snl-switch [toggleState]="toggleScrubberVal" (toggle)="toggleScrubberUsage($event)"
                            [activeText]="'Yes'" [inActiveText]="'No'"></snl-switch>
                    </div>
                        <!-- ---yes to no -->
                    <!-- <ng-container *ngIf="toggleScrubberVal === false"> -->
                        <div class="datepickerScrubberUsage mt-24">
                            <snl-date-picker-dropdown datePickerType="date"
                                (selectedDate)="scrubberUsageDate($event)" 
                                title="Effective date of change"
                                [min]="minSelectableDate"
                                class="scrubberEffectiveDate">
                            </snl-date-picker-dropdown>                      
                        </div>
                        <div class="multi-input reasonForchangeScrubber editPoolPointsVal_1ReasonInput mt-24">
                            <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                                [isError]="isTextError" (fieldValue)="scrubberUsagefieldValue($event)">
                            </snl-multi-line-input>                
                        </div>   
                        <div class="currentPool mt-24" >
                            <p class="body-b color__secondary">Current scrubber points</p>
                            <p class="section-title color__primary">
                                {{getScrubberData?.currentScrubberPoints | negativeToBracket}}
                            </p>
                        </div>
                        <ng-container *ngIf="getScrubberData?.hasPreviousChange === true">
                            <div class="currentPool mt-24" *ngIf="getScrubberData?.currentEffectiveDate">
                                <p class="body-b color__secondary">Effective date of change</p>
                                <p class="section-title color__primary">
                                    {{getScrubberData?.currentEffectiveDate | date:'dd MMM yyyy'}}
                                </p>
                            </div>
                            <div class="currentPool mt-24" *ngIf="getScrubberData?.currentReason">
                                <p class="body-b color__secondary">Reason for change</p>
                                <p class="section-title color__primary">
                                    {{getScrubberData?.currentReason}}
                                </p>
                            </div>
                        </ng-container> 
                    <!-- </ng-container>                   -->
                </div>
            </ng-container>
             <ng-container *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_2_YesCase'">
                <div class="editScrubberUsageVal_2"  [ngClass]="isScrubberUsagePointsInputError() ? 'displayErrmsg' : ''">
                    <div class="d-flex justify-content-between">
                        <p class="color__primary body-b1">Is Scrubber in use</p>
                        <snl-switch [toggleState]="toggleScrubberVal" (toggle)="toggleScrubberUsage($event)"
                            [activeText]="'Yes'" [inActiveText]="'No'"></snl-switch>
                    </div>
                       <!-- ----no to yes -->
                    <!-- <ng-container *ngIf="toggleScrubberVal === true"> -->
                        <form [formGroup]="scrubberUsageForm" class="scrubberUsageForm">
                            <div class="scrubber-input">
                                <snl-input [label]="'Scrubber points'" 
                                    [helperText]="searchText" [type]="'text'"
                                    [isError]="isScrubberUsagePointsInputError()"
                                    [errorMessage]="getScrubberUsagePointsInputErrorMessage()"
                                    [value]="scrubberUsageForm.value.scrubberUsagePoints"
                                    formControlName="scrubberUsagePoints"
                                    (focusout)="handleFocusOutScrubberUsagePoints($event)"
                                >
                                </snl-input>
                            </div>
                        </form>
                        <div class="datepickerScrubberUsage mt-24">
                            <snl-date-picker-dropdown datePickerType="date"
                                (selectedDate)="scrubberUsageDate($event)" 
                                title="Effective date of change"
                                [min]="minSelectableDate"
                                class="scrubberEffectiveDate">
                            </snl-date-picker-dropdown>                      
                        </div>
                        <div class="multi-input reasonForchangeScrubber editPoolPointsVal_1ReasonInput mt-24">
                            <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                                [isError]="isTextError" (fieldValue)="scrubberUsagefieldValue($event)">
                            </snl-multi-line-input>                
                        </div>   
                        <ng-container *ngIf="getScrubberData?.hasPreviousChange === true">
                            <div class="currentPool mt-24" *ngIf="getScrubberData?.currentEffectiveDate">
                                <p class="body-b color__secondary">Current effective date of change</p>
                                <p class="section-title color__primary">
                                    {{getScrubberData?.currentEffectiveDate | date:'dd MMM yyyy'}}
                                </p>
                            </div>
                            <div class="currentPool mt-24" *ngIf="getScrubberData?.currentReason">
                                <p class="body-b color__secondary">Current reason for change</p>
                                <p class="section-title color__primary">
                                    {{getScrubberData?.currentReason}}
                                </p>
                            </div>
                        </ng-container> 
                    <!-- </ng-container>            -->
                </div>
            </ng-container>
            <ng-container *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_3'">
                <div class="editScrubberUsageVal_3" [ngClass]="isScrubberUsagePointsInputError() ? 'displayErrmsg' : ''">
                    <div class="scrubberNotificationWrap subUsgNotificationWrap" *ngIf="showScrubberDiscardBanner">
                        <div class="d-flex col-gap-8">                 
                            <figure>
                                <img src="assets/img/infoBlue.svg" alt="information">
                            </figure>
                                             
                            <span class="body-b1 color__primary">To change the current details, you need
                                to discard the upcoming change first.</span>             
                        </div>
                    </div>
                    <div class="mt-24">
                        <p class="color__secondary body-b">Current - Is Scrubber in use?</p>
                        <p class="color__primary section-title">{{getScrubberData?.currentScrubberUsage === true ? 'Yes' : 'No'}}</p>
                    </div>
                    <ng-container *ngIf="getScrubberData?.currentScrubberUsage">
                        <div class="mt-24">
                            <p class="color__secondary body-b">Current scrubber points</p>
                            <p class="color__primary section-title">{{getScrubberData?.currentScrubberPoints | negativeToBracket }}</p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="getScrubberData?.hasPreviousChange">
                        <div class="mt-24" *ngIf="getScrubberData?.currentEffectiveDate">
                            <p class="body-b color__secondary">Effective date of change</p>
                            <p class="section-title color__primary">
                            {{getScrubberData?.currentEffectiveDate | date:'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="mt-24" *ngIf="getScrubberData?.currentReason">
                            <p class="body-b color__secondary">Reason for change</p>
                            <p class="section-title color__primary">
                                {{getScrubberData?.currentReason}}
                            </p>
                        </div>
                    </ng-container>
                    <div class="single-line"></div>
                    <div class="d-flex mt-24 justify-content-between">
                        <div>
                            <p class="body-b color__secondary">Upcoming - Is Scrubber in use?</p>
                            <p class="color__primary section-title">{{getScrubberData?.upcomingScrubberUsage === true ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="d-flex col-gap-8 discardWrapSubUsg" (click)="discardScrubberEvent()">
                            <figure >
                                <img src="assets/img/delBlue.svg" alt="information">
                            </figure>
                            <span class="discardTextSubUsg section-title">Discard</span>
                        </div>
                    </div>
                    <ng-container *ngIf="getScrubberData?.upcomingScrubberUsage">
                        <form [formGroup]="scrubberUsageForm" class="scrubberUsageForm upcomingScrubberForm">
                            <div class="scrubber-input">
                                <snl-input [label]="'Scrubber points'" 
                                    [helperText]="searchText" [type]="'text'"
                                    [isError]="isScrubberUsagePointsInputError()"
                                    [errorMessage]="getScrubberUsagePointsInputErrorMessage()"
                                    [value]="scrubberUsageForm.value.scrubberUsagePoints"
                                    formControlName="scrubberUsagePoints"
                                    (focusout)="handleFocusOutScrubberUsagePoints($event)"
                                >
                                </snl-input>
                            </div>
                        </form>
                    </ng-container>
                    <div class="datepickerScrubberUsage datepickerUpcomingScrubberUsage mt-24" *ngIf="upcomingScrubberEffectiveDate as effectiveDate">
                        <snl-date-picker-dropdown datePickerType="date"
                            (selectedDate)="upcomingScrubberUsageDate($event)" 
                            title="Effective date of change"
                            [min]="minSelectableDate"
                            [startMonthDate]="effectiveDate"
                            [setDefaultDate]="false"
                            class="scrubberEffectiveDate"></snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input reasonForchangeScrubber editPoolPointsVal_1ReasonInput mt-24">
                        <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLength"
                            [value]="upcomingScrubberReasonValue"
                            [isError]="isTextError" (fieldValue)="upcomingScrubberUsageValue($event)">
                        </snl-multi-line-input>
                    </div>
                    
                </div>
            </ng-container>
            <ng-container *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_4' && openEditScrubberUsage === true">
                <div class="editScrubberUsageVal_4" [ngClass]="isScrubberUsagePointsInputError() ? 'displayErrmsg' : ''">
                    <div class="scrubberNotificationWrap subUsgNotificationWrap">
                        <div class="d-flex col-gap-8">                        
                            <figure>
                                <img src="assets/img/infoBlue.svg" alt="information">
                            </figure>                   
                            <span class="body-b1 color__primary">You can modify the details until <span
                                class="section-title color__primary fw-700">{{getScrubberData?.nextCalculationDate | date: 'dd MMM yyyy'}}</span> without affecting
                                distrubtion.
                            </span>    
                        </div>
                    </div>
                    <div class="mt-24">
                        <p class="color__secondary body-b">Current - Is Scrubber in use?</p>
                        <p class="color__primary section-title">{{getScrubberData?.currentScrubberUsage === true ? 'Yes' : 'No'}}</p>
                    </div>
                    <ng-container *ngIf="getScrubberData?.currentScrubberUsage">
                        <div class="mt-24">
                            <form [formGroup]="scrubberUsageForm" class="scrubberUsageForm pendingScrubberUsage">
                            <div class="scrubber-input">
                                <snl-input [label]="'Scrubber points'" 
                                    [helperText]="searchText" [type]="'text'"
                                    [isError]="isScrubberUsagePointsInputError()"
                                    [errorMessage]="getScrubberUsagePointsInputErrorMessage()"
                                    [value]="scrubberUsageForm.value.scrubberUsagePoints"
                                    formControlName="scrubberUsagePoints"
                                    (focusout)="handleFocusOutScrubberUsagePoints($event)"
                                >
                                </snl-input>
                            </div>
                        </form>
                        </div>
                    </ng-container>
                    <div class="datepickerLngUsage datepickerScrubberUsage mt-24" *ngIf="pendingScrubberEffectiveDate as effectiveDate">                        
                        <snl-date-picker-dropdown datePickerType="date"
                            (selectedDate)="pendingScrubberUsageDate($event)" 
                            title="Effective date of change"
                            [min]="minSelectableDate"
                            [startMonthDate]="effectiveDate"
                            [setDefaultDate]="false"
                            class="scrubberEffectiveDate"></snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input reasonForchangeScrubber editPoolPointsVal_1ReasonInput mt-24">
                        <snl-multi-line-input 
                            [label]="'Reason for change'" [maxLength]="maxLength"
                            [value]="pendingScrubberUsageReason"
                            [isError]="isTextError" (fieldValue)="pendingScrubberUsageValue($event)">
                        </snl-multi-line-input>
                    </div>    
                    <div class="single-line"></div>               
                    <div class="d-flex mt-24 justify-content-between">
                        <div>
                            <p class="body-b color__secondary">Previous - Is Scrubber in use?</p>
                            <p class="color__primary section-title">{{getScrubberData?.previousScrubberUsage === true ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="d-flex col-gap-8 discardWrapSubUsg" (click)="revertScrubberEvent()">
                            <figure >
                                <img src="assets/img/arrowLeftIcon.svg" alt="arrowLeftIcon">
                            </figure>
                            <span class="discardTextSubUsg section-title" >Restore previous
                            </span>
                        </div>
                    </div>
                    <ng-container *ngIf="!getScrubberData?.currentScrubberUsage">
                        <div class="mt-24">
                            <p class="color__secondary body-b">Previous scrubber points</p>
                            <p class="color__primary section-title">{{getScrubberData?.previousScrubberPoints | negativeToBracket }}</p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="getScrubberData?.hasPreviousChange">
                        <div class="currentPool mt-24" *ngIf="getScrubberData?.previousEffectiveDate">
                            <p class="body-b color__secondary">Effective date of change</p>
                            <p class="section-title color__primary">
                               {{getScrubberData?.previousEffectiveDate | date: 'dd MMM yyyy'}}
                            </p>
                        </div>
                        <div class="currentPool mt-24" *ngIf="getScrubberData?.previousReason">
                            <p class="body-b color__secondary">Reason for change</p>
                            <p class="section-title color__primary">
                                {{getScrubberData?.previousReason}}
                            </p>
                        </div>
                    </ng-container>           
                </div>
            </ng-container>
        </div>
        <div sidePanelFooterContent>
            <!-- <ng-container *ngIf="getScrubberData?.hasPreviousChange"> -->
                <ng-container *ngIf=" getScrubberData?.status === 'noChange'" >
                    <snl-button *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_1'" type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                        [disabled]="!noChangeScrubberEffectiveDate || !scrubberUsageReason || scrubberUsageReasonError">
                        Save and update
                    </snl-button>         
                    <snl-button *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_2_NoCase'" type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                        [disabled]="!selectedScrubberUsageDate || scrubberUsageReason === '' || scrubberUsageReasonError">
                        Save and update
                    </snl-button> 
                    <snl-button *ngIf="editScrubberUsageVal === 'editScrubberUsageVal_2_YesCase'" type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                        [disabled]="!selectedScrubberUsageDate || scrubberUsageReason === '' || scrubberUsageReasonError || !scrubberUsageVal?.scrubberUsagePoints">
                        Save and update
                    </snl-button> 
                </ng-container>     
                <snl-button *ngIf="getScrubberData?.status === 'upcomingChange' " type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                    [disabled]="!upcomingScrubberEffectiveDate || !upcomingScrubberReasonValue || upcomingScrubberUsageReasonError"><!--  || !discardScrubberSuccess -->
                    Save and update
                </snl-button> 
                <ng-container *ngIf="getScrubberData?.status === 'pendingCalculation' "><!-- editScrubberUsageVal_4  -->
                    <snl-button  *ngIf="getScrubberData?.currentScrubberUsage"  type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                        [disabled]="!pendingScrubberUsageDate || !pendingScrubberUsageReason || pendingScrubberUsageReasonError">
                        Save and update
                    </snl-button>
                     <snl-button  *ngIf="!getScrubberData?.currentScrubberUsage"  type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                        [disabled]="!selectedScrubberUsageDate || !scrubberUsageReason || scrubberUsageReasonError">
                        Save and update
                    </snl-button>
                </ng-container>                
            <!-- </ng-container>
            <ng-container *ngIf="!getScrubberData?.hasPreviousChange">
                <snl-button   *ngIf="getScrubberData?.status === 'noChange' " type="primary" size="large" (click)="openEditScrubberUsage = false;updateScrubberUsage()" 
                    [disabled]="!selectedScrubberUsageDate || scrubberUsageReason === '' || scrubberUsageReasonError || !scrubberUsageVal?.scrubberUsagePoints">
                    Save and update 7
                </snl-button>
            </ng-container> -->
           
            <snl-button type="secondary" size="large"
            (click)="openEditScrubberUsage = false;closeScrubberSidePanel()"
              >Cancel</snl-button>
        </div>
    </snl-side-panel>
</div>


<!-- ----discard scrubber usage -->
  <snl-modal (click)="openDiscardScrubberUsage = false" [type]="'small'" [open]="openDiscardScrubberUsage">
  <div slot="heading" class="ppLargeModalHeading"> Discard upcoming change </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="body-b1 color__primary">
            You are about to cancel the scheduled scrubber usage change, effective from 
            <span class="section-title">
                {{getScrubberData?.upcomingEffectiveDate | date:'dd MMM yyyy'}}.
            </span>
            <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openDiscardScrubberUsage = false;discardScrubberUsage()">Discard</snl-button>
      <snl-button type="secondary" size="large" (click)="openDiscardScrubberUsage = false;cancelDiscardScrubberUsage()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>


<!-- ---restore scrubber usage---- -->
  <snl-modal (click)="openRestoreScrubberUsage = false" [type]="'small'" [open]="openRestoreScrubberUsage">
    <div slot="heading" class="ppLargeModalHeading"> Restore previous scrubber usage</div>
    <div slot="modalContent" class="modal-content">
        <div class="textWrap">
            <div class="color__primary body-b1">
            You are about to change the current scrubber back to the previous configuration. 
            <span class="yesProceedTxt">Are you sure you want to proceed?</span>
            </div>       
        </div>
    </div>
    <div slot="modalFooter">
        <div class="btnWrap">
        <snl-button type="primary" size="large" (click)="openRestoreScrubberUsage = false;revertScrubberChanges();">Restore</snl-button>
        <snl-button type="secondary" size="large" (click)="openRestoreScrubberUsage = false;cancelScrubberRestore()">Cancel</snl-button>
        </div>
    </div>
</snl-modal>